import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  position: fixed;
  right: 60px;
  top: 60px;
  width: 400px;
  z-index: 2000;
  background-color: ${props => props.theme.themeColors.sidebars.background};
  border-left: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
  @media all and (max-width: 1200px) {
    width: calc(50% - 60px);
  }
`;

export const WrapperLoad = styled.div`
  height: 100%;
  position: fixed;
  right: 60px;
  top: 60px;
  width: 400px;
  z-index: 2000;
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.themeColors.sidebars.background};
  border-left: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  justify-content: center;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
`;

export const StyledHeader = styled.div`
  align-items: center;
  background: ${({ theme }) =>
    theme.themeColors.sidebars.bookmarks.headerBackground};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  min-height: 40px;
  overflow: hidden;
`;

export const StyledBody = styled.div`
  height: calc(100% - 100px);
  overflow-y: auto;
`;

export const StyledBodyLoad = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props =>
  props.active
    ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
    : props.theme.themeColors.sidebars.thumbnails.textColor};
  height: calc(100% - 100px);
  overflow-y: auto;
`;

export const DocCard = styled.div`
  display: grid;
  position: relative;
  margin: 10px;
  cursor: pointer;
  background: ${props => props.theme.themeColors.controlBar.background};
  &:hover {
    background-color: rgba(106,160,241,0.1);
  }  
`;

export const DocItem = styled.div`
  height: 64px;
  display: grid;
  grid-template-columns: 50px 1fr;
  height: 64px;
`;

export const Text = styled.div`
  color: ${props =>
  props.active
    ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
    : props.theme.themeColors.sidebars.thumbnails.textColor};
  margin-bottom: 5px;
  margin-top: 5px;
  &:nth-child(2) {
    color: ${props =>
    props.active
      ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
      : props.theme.themeColors.sidebars.thumbnails.textColor};
    font-size: 14px;
    opacity: 0.4;
  }
  white-space: nowrap;
  max-width: 372px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextBlock = styled.div`  
  display: flex;
  align-items: center;
  margin-right: 64px;
  gap: 0;
`;

export const DropdownContainer = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;
  &:hover {
    background-color: rgba(106,160,241,0.1);
  }
  top: 12px;
  right: 12px;
  z-index: 4000 !important;
`;

export const DropdownButton = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Dropdown = styled.ul`
    background: ${props => props.theme.themeColors.controlBar.background};
    box-shadow: rgba(0,0,0,.03) 0px -1px 0px inset, rgba(0,0,0,.2) 0px 1px 3px;    
    list-style: none;
    padding: 0px;
    margin: 0px;
    width: 200px;
    position: absolute;
    top: calc(-100% - 2px);
    right: 0px;   
`;

export const DropdownItem = styled.li`
    color: ${props =>
      props.active
        ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
        : props.theme.themeColors.sidebars.thumbnails.textColor}; 
    padding: 10px 5px;
    display: flex;
    align-items: center;
    gap: 6px;
    z-index: 400;
    cursor: pointer;
    &:hover {
      background-color: rgba(106,160,241,0.1);
    }
`;

export const CommentText = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 14px;
  margin-left: 50px;
  padding-bottom: 15px;
  padding-right: 20px;
  color: ${props =>
    props.active
      ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
      : props.theme.themeColors.sidebars.thumbnails.textColor}; 
  & p {
    margin: 0px;
  }
`;